export default __webpack_public_path__ + "static/media/pic3.adfd6b17.jpg";